module.exports = __webpack_public_path__ + "img/signs3.67e83e95.jpg";